import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AdoptHero from './components/AdoptHero';
import WhyAdopt from './components/WhyAdopt';
import AdoptionProcess from './components/AdoptionProcess';
import AdoptableCatsGrid from './components/AdoptableCatsGrid';
import ShelterPartners from './components/ShelterPartners';
import SuccessStories from './components/SuccessStories';
import AdoptCTA from './components/AdoptCTA';
import AdoptionInquiryModal from './components/AdoptionInquiryModal';
import SEOHead from '../../components/feature/SEOHead';

const adoptSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Adopt a Cat - Find Adoptable Cats Near You | MeowCentral',
  url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/adopt`,
  description: 'Find adoptable cats and kittens near you. Browse profiles of cats looking for forever homes, connect with local shelters, and start your adoption journey today.',
  mainEntity: {
    '@type': 'ItemList',
    name: 'Adoptable Cats',
    description: 'Cats and kittens available for adoption from partner shelters.',
  },
};

export default function AdoptPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCat, setSelectedCat] = useState('');
  const [selectedShelter, setSelectedShelter] = useState('');
  const [showMobileCTA, setShowMobileCTA] = useState(false);

  const handleInquiry = (catName: string, shelterName: string) => {
    setSelectedCat(catName);
    setSelectedShelter(shelterName);
    setModalOpen(true);
  };

  // Show mobile CTA after scrolling past hero
  useState(() => {
    const handleScroll = () => {
      setShowMobileCTA(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div className="min-h-screen">
      <SEOHead
        title="Adopt a Cat - Find Adoptable Kittens & Cats Near You | MeowCentral"
        description="Browse adoptable cats and kittens from partner shelters. Find your perfect feline companion, learn about the adoption process, and give a cat a loving forever home."
        keywords="adopt a cat, adoptable cats, cat adoption, kittens for adoption, cat shelter, rescue cats, adopt a kitten"
        canonical="/adopt"
        schema={adoptSchema}
      />
      <Navbar />
      <main>
        <AdoptHero />
        <WhyAdopt />
        <AdoptionProcess />
        <div id="adoptable-cats">
          <AdoptableCatsGrid onInquiry={handleInquiry} />
        </div>
        <ShelterPartners />
        <SuccessStories />
        <AdoptCTA />
      </main>
      <Footer />
      <AdoptionInquiryModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        catName={selectedCat}
        shelterName={selectedShelter}
      />

      {/* Sticky Mobile CTA */}
      {showMobileCTA && (
        <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-200 shadow-2xl p-4 animate-slide-up">
          <a
            href="#adoptable-cats"
            className="w-full flex items-center justify-center gap-2 px-6 py-3.5 bg-accent hover:bg-accent/90 text-white font-heading font-bold text-sm rounded-full transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-heart-line text-lg"></i>
            Adopt a Cat Today
          </a>
        </div>
      )}
    </div>
  );
}